import React from "react";
import FooterIcon from "./FooterIcon";
import iconFb from "assets/img/social-icons/icon_facebook_v01.png";
import iconTwitter from "assets/img/social-icons/icon_twitter_v02.png";
import iconYoutube from "assets/img/social-icons/icon_youtube_v01.png";
import iconInstagram from "assets/img/social-icons/icon_instagram_v01.jpg";

const styles = {
    iconFacebook: {
        background: "url(" + iconFb + ") no-repeat"
    },
    iconTwitter: {
        background: "url(" + iconTwitter + ") no-repeat"
    },
    iconYoutube: {
        background: "url(" + iconYoutube + ") no-repeat"
    },
    iconInstagram: {
        background: "url(" + iconInstagram + ") no-repeat"
    }
};

const Footer = ({dswd}) => {

    function getYear(){
        let date = new Date();
        let n = date.getFullYear();

        return n;
    }

    return (
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-sm-4 col-sm-push-8">
                        <h2>Follow us on:</h2>

                        <ul className="social-icons list-inline">
                            <FooterIcon
                                link="https://www.facebook.com/worldvisionph"
                                icon={styles.iconFacebook}
                                title="Facebook"
                            />
                            <FooterIcon
                                link="https://twitter.com/worldvisionph/"
                                icon={styles.iconTwitter}
                                title="Twitter"
                            />
                            <FooterIcon
                                link="https://www.youtube.com/user/worldvisionph/"
                                icon={styles.iconYoutube}
                                title="Youtube"
                            />
                            <FooterIcon
                                link="https://www.instagram.com/worldvisionphl/"
                                icon={styles.iconInstagram}
                                title="Instagram"
                            />
                        </ul>
                    </div>

                    <div className="col-sm-8 col-sm-pull-4 col-xs-12">
                        <p>
                            © Copyright {getYear()} World Vision Development Foundation
                            Inc.
                            <br />
                            389 Quezon Avenue corner West 6th St. West Triangle,
                            Quezon City 1104 PH
                            <br />
                            Phone: (+632) 8372 7777 
                        </p>
                        <p>
                        {/* DSWD-SB-SP-00040-2021 valid from August 9, 2021 to August 10, 2022; Nationwide. */}
                        {dswd}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
